import { getCurrentVenueHashPrefix, navigateReportsHash } from 'src/url-states/reports-hash';

export const parseBookingsFiltersFromWindowHash = (): { type: string; date: string } | null => {
  const rawHash = typeof window === 'undefined' ? '' : window.location.hash;
  const hash = rawHash.replace(/^#\/?/, '');
  const match = hash.match(/^venue\/\d+\/bookings\/([^/]+)\/([^/]+)/);

  if (!match) {
    return null;
  }

  return {
    type: decodeURIComponent(match[1]),
    date: decodeURIComponent(match[2]),
  };
};

export const navigateBookingsReportHash = (type: string, date: string): void => {
  const prefix = getCurrentVenueHashPrefix();
  if (!prefix) {
    return;
  }
  navigateReportsHash(`${prefix}/bookings/${type}/${date}`);
};
